import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";

function Home() {
  const cookie = new Cookies();
  const [normas, setNormas] = useState([]);
  const [idNormaSeleccionada, setIdNormaSeleccionada] = useState("");
  const isAuthenticated = cookie.get("nitNumber");
  useEffect(() => {
    if (!isAuthenticated) {
      Swal.fire({
        icon: "warning",
        title: "Debe iniciar sesión",
        text: "Por favor, inicie sesión para continuar.",
        confirmButtonText: "Aceptar",
      }).then(() => {
        window.location.href = "/login";
      });
    }
  }, [isAuthenticated]);
  useEffect(() => {
    axios
      .get(
        "https://autodiagnosticoback.azurewebsites.net/api/ObtenerTodasNormas",
        {
          auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
        }
      )
      .then((res) => setNormas(res.data))
      .catch((err) => console.error("Error al obtener normas:", err));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    const nitNumber = cookie.get("nitNumber");

    // Validar NIT antes de enviar
    if (!nitNumber || nitNumber === "undefined" || nitNumber.trim() === "") {
      Swal.fire({
        icon: "error",
        title: "NIT inválido",
        text: "No se encontró un NIT válido. Por favor inicie sesión nuevamente.",
      }).then(() => {
        cookie.remove("nitNumber"); // Limpia la cookie dañada
        window.location.href = "/login";
      });
      return;
    }

    axios
      .post(
        "https://autodiagnosticoback.azurewebsites.net/api/CreaEvaluacion",
        {
          cliente: nitNumber,
          estado: "en progreso",
          idNormaCuestionario: idNormaSeleccionada,
        }
      )
      .then((res) => {
        const response = res.data;
        if (response === 2) {
          Swal.fire("Ya presentó esta evaluación", "", "warning");
        } else {
          Swal.fire("Evaluación creada", "", "success").then(() => {
            window.location.href = `/#/NTC/${response}`;
          });
        }
      })
      .catch((err) => {
        console.error("Error al crear evaluación:", err);
        Swal.fire("Error", "No fue posible crear la evaluación", "error");
      });
  };

  const esAfiliado = cookie.get("afiliado") !== "NO AFILIADO";

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <center>
            <h2 className="text-primary">Autoevaluación</h2>
          </center>

          <div className="card my-4">
            <form className="card-body p-lg-5" onSubmit={handleSubmit}>
              <section className="text-justify text-primary">
                <h2>¡Bienvenido!</h2>
              </section>
              <p>
                Módulo de autoevaluaciones de cumplimiento de Normas Técnicas y
                Buenas Prácticas de Gestión de ICONTEC. Aquí podrá seleccionar
                normas para evaluar su organización y generar reportes
                consolidados.
              </p>
              <p>
                <strong>1. Mejora continua y gestión de riesgos:</strong>{" "}
                detecte desviaciones, oportunidades y riesgos.
              </p>
              <p>
                <strong>2. Eficiencia:</strong> identifique ineficiencias y
                mejore su productividad.
              </p>
              <p>
                <strong>3. Transferencia de conocimiento:</strong> manténgase al
                día con nuevas tendencias y tecnologías.
              </p>
              <p>
                <strong>4. Cultura de cumplimiento:</strong> fomente una cultura
                organizacional basada en la integridad y el cumplimiento.
              </p>
              <p>
                ¡Bienvenido a este viaje hacia la excelencia en el cumplimiento
                de normas y buenas prácticas de gestión!
              </p>

              <hr />

              <h5 className="text-center text-primary mt-4">
                Escoja una norma que desea presentar
              </h5>

              <div className="form-group row mt-3">
                {esAfiliado ? (
                  <select
                    className="form-control"
                    onChange={(e) => setIdNormaSeleccionada(e.target.value)}
                    required
                  >
                    <option value="">Seleccione la norma</option>
                    {normas.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.norma}
                      </option>
                    ))}
                  </select>
                ) : (
                  <div className="col-12">
                    <div className="alert alert-warning text-center">
                      Si desea obtener este beneficio, por favor contacte con el
                      departamento comercial de Icontec.
                    </div>
                  </div>
                )}
              </div>

              {idNormaSeleccionada && (
                <div className="form-group row mt-3">
                  <div className="col-sm-12 text-center">
                    <button
                      type="submit"
                      className="btn btn-primary btn-user btn-block"
                    >
                      Crear nuevo
                    </button>
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
